import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getLastAdjustmentComment } from 'apis/adjustmentComments.api';

const useGetLastAdjustmentComments = (params, conds = {}) => {
  const { data: adjustmentCommentData, ...rest } = useQuery(
    ['lastProjectAdjustmentComments', params],
    () => getLastAdjustmentComment(params),
    {
      ...conds,
    }
  );

  const adjustmentComment = useMemo(
    () => adjustmentCommentData?.data ?? null,
    [adjustmentCommentData]
  );

  return {
    data: adjustmentComment,
    ...rest,
  };
};

export default useGetLastAdjustmentComments;
